import type { MessageDescriptor } from 'react-intl';
import { ValidationFailedError } from '@/utils/request';
import { isSetPasswordBackendError } from '../constants';
import { Page as messages } from '../messages';

export const getErrorMessage = (error: unknown): MessageDescriptor => {
  const possibleError =
    error instanceof ValidationFailedError && error.errors && error.errors[0] ? error.errors[0].type : error;
  return isSetPasswordBackendError(possibleError) ? messages[possibleError] : messages.setPasswordError;
};
